import AxiosDefault from "services/AxiosDefault";

export const GetLprDataAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/settings/lpr/lpr-data",
    data,
  });
  return response;
};
